import type { ComponentType } from "react";

export type BannerAlertTone = "info" | "warning" | "danger";

export interface IBannerAlertAction {
  label: string;
  to: string;
}

export interface IBannerAlert {
  /** Stable key — also the dismissal key if dismissal is ever added. */
  id: string;
  tone: BannerAlertTone;
  icon: ComponentType<{ className?: string; "aria-hidden"?: boolean }>;
  title: string;
  description: string;
  /**
   * Higher wins. Ranking is explicit rather than derived from `tone` because
   * severity and urgency are not the same axis — an overdue compliance item
   * outranks a security warning even though both could be styled `danger`.
   */
  priority: number;
  /** Primary CTA — carries the alert's tone. */
  action?: IBannerAlertAction;
  /** Optional alternative route out; rendered neutral so it cannot compete with `action`. */
  secondaryAction?: IBannerAlertAction;
}

/** Shared priority band so the ordering of the whole set is readable in one place. */
export const ALERT_PRIORITY = {
  OFFBOARDING_INVITATION: 100,
  POLICIES_OVERDUE: 90,
  DOCUMENTS_EXPIRED: 85,
  ATTENDANCE_GAP: 70,
  MFA_DISABLED: 60,
  POLICIES_PENDING: 50,
  DOCUMENTS_EXPIRING: 40,
} as const;
